@if (!isMobileScreen) {
<div class="vtz-header">
  <button mat-raised-button [matMenuTriggerFor]="menu"
    aria-label="Open support and navigation menu"
    aria-haspopup="true"
    aria-expanded="false"
    id="accessibility-button"
    i18n-aria-label>
    <mat-icon style="color: #253E60;">menu</mat-icon>
    <span style="color: #253E60;" i18n>MENU</span>
  </button>
  <mat-menu #menu="matMenu" 
    aria-label="Support and navigation menu"
    i18n-aria-label
    [attr.focusFirstItem]="true">
    @if(sessionService.activeSessionCheck() && apiAbout.idUploadFlow) {
      <button mat-menu-item (click)="gotoDashboard()"
        aria-label="Return to the dashboard"
        i18n-aria-label>
        <mat-icon aria-hidden="true">dashboard</mat-icon>
        <span i18n>Dashboard</span>
      </button>
    }

    <a href="{{clientFAQ}}" target="_blank" rel="noopener noreferrer"
      id="faq-button" 
      mat-menu-item 
      [attr.aria-label]="'FAQ - Opens in new window'"
      i18n-aria-label>
      <mat-icon aria-hidden="true">not_listed_location</mat-icon>
      <span i18n>FAQ</span>
    </a>
    <a href="mailto:{{supportEmail}}" target="_blank" rel="noopener noreferrer" 
      id="help-button" 
      mat-menu-item 
      [attr.aria-label]="'Contact Support - Opens email client'"
      i18n-aria-label>
      <mat-icon aria-hidden="true">contact_mail</mat-icon>
      <span i18n>CONTACT SUPPORT</span>
    </a>
  </mat-menu>
  <img src="/assets/images/logo_tzero.png" alt="Voatz logo" class="vtz-header__logo" id="logo_voatz">

  @if (!isMobileScreen) {
    <div class="vtz-header__left">
      <app-user-menu></app-user-menu>
    </div>
  }

</div>
}
@if (apiAbout.getSpinnerVisibility() | async) {
<div class="progressSpinner">
  <mat-spinner [diameter]="300" color="primary"></mat-spinner>
</div>
}

<router-outlet (activate)="onActivate()"></router-outlet>
<app-browser-support-modal></app-browser-support-modal>
<footer aria-label="footer">
  <app-footer></app-footer>
</footer>